import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {reposCommitActivityAppBuilder} from './config/app-builder'

import {commitActivityRoute} from './routes/commit-activity-route'
import {Index} from './routes/Index'

export const reposCommitActivityApp = reposCommitActivityAppBuilder.createDataRouterAppFromRoutes([
  commitActivityRoute.toRoute({Component: Index}),
])
registerDataRouterApp(reposCommitActivityApp)
